export default __webpack_public_path__ + "4d4a1529973cddb40229d80e3cede3be.svg";